/* eslint-disable import/prefer-default-export */

export const extraTableIdentificatorList = [
  'Email:',
  'Mobile Number:',
  'Telegram Id:',
];
